import React from 'react'
import {Link} from "react-router-dom";
import {BiCaretRight} from 'react-icons/bi';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar, A11y, Autoplay} from 'swiper';


/*Description imports */
import './itemdesc.css'


/*carousel imports */
import './gallery.css'



  /*portfolio item imports */
  import './formerportfolio.css'
  import IMG1 from '../../assets/one-recruiter2.png'
  import IMG2 from '../../assets/one-recruiter3.png'
  import IMG3 from '../../assets/one-recruiter4.png'
  

/*footer imports */
import Footer from '../../components/footer/Footer.js'

const Item1 = () => {
    return (
      <div div onLoad={()=>{window.scrollTo(0, 130)}}>

<section >
     
<div style={{display:"flex",justifyContent:"center",margin:"4rem"}}>
       <Link to={"/#portfolio"}><a href="#" id='testimonials' className="btn btn-primary">Home</a></Link> 
     </div>
     
     
      <h5>Recruiter Live!</h5>
      <h2>Gallery</h2>
     
   <Swiper className="gallery__container"
   //swiper js options
   modules={[ Pagination, Scrollbar, A11y,Autoplay]}
   
   autoplay={{
    delay: 3500,
    disableOnInteraction: true,
  }}
   scrollbar={{ draggable: true }}
   slidesPerView={1}
   spaceBetween={50}
   pagination={{clickable:true}}
   
   > 
   {/*1 */}
  
   
    <SwiperSlide className="gallery-testimonial">
    <article className="formerportfolio__item" >
     <div className="formerportfolio__item-image">
      <img src={IMG1} alt="portfolio item 1" />
    </div>
    <h3>( I )</h3>
    <div className="formerportfolio__item-cta">
    <a href="https://github.com/Dagogo-Clinton-Uranta/recruiter-live.git" className="btn">Project Code(Github)</a>
    <a href="https://onerecruiter-employer.netlify.app/home" className="btn btn-primary" target="_blank" rel="noreferrer">Live Webpage</a>
    </div>
   </article>
    </SwiperSlide>
    


     {/*2 */}
     <SwiperSlide className="gallery-testimonial">
    <article className="formerportfolio__item" >
     <div className="formerportfolio__item-image">
      <img src={IMG2} alt="portfolio item 1" />
    </div>
    <h3>(II)</h3>
    <div className="formerportfolio__item-cta">
    <a href="https://github.com/Dagogo-Clinton-Uranta/recruiter-live.git" className="btn">Project Code(Github)</a>
    <a href="https://onerecruiter-employer.netlify.app/home" className="btn btn-primary" target="_blank" rel="noreferrer">Live Webpage</a>
    </div>
   </article>
    </SwiperSlide>

 {/*3 */}
 <SwiperSlide className="gallery-testimonial">
    <article className="formerportfolio__item" >
     <div className="formerportfolio__item-image">
      <img src={IMG3} alt="portfolio item 1" />
    </div>
    <h3>(III)</h3>
    <div className="formerportfolio__item-cta">
    <a href="https://github.com/Dagogo-Clinton-Uranta/recruiter-live.git" className="btn">Project Code(Github)</a>
    <a href="https://onerecruiter-employer.netlify.app/home" className="btn btn-primary" target="_blank" rel="noreferrer">Live Webpage</a>
    </div>
   </article>
    </SwiperSlide>


  </Swiper> 

    </section>

{/*END OF PROJECT DISPLAY SECTION */}


    <section id='services'>
    <h5>Recruiter Live!</h5>
    <h2>Design Decisions</h2>

    <div className="container decisions__container ">
      <article className="service">
        <div className="service__head">
          <h3>Design Insights include :-</h3>
        </div>

        <ul className="service__list">
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>
           "Recruiter Live!" is a tool to be used by businesses to streamline the process of processing and hiring of candidates.</p>
          </li>
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>Upon joining, Businesses Are Presented with the option of adding a new job, and then adding  candidates who are interviewing, to that job.</p>
          </li>
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>Posting a job requires setting interview times, candidate requirements and the number of interview rounds to be specified</p>
          </li>

          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>Once a job is posted a pipeline for handling candidates is then opened up, in the "action Items" section,and then candidates can be tracked and processed as required </p>
          </li>
         
        </ul>
      </article>
     
    
  </div>     
    
    </section>

     {/*END OF  DESCRITPION SECTION*/}

    

    <section id='services'>
    <h5>Chat App</h5>
    <h2>Technology Involved</h2>

    <div className="container decisions__container ">
      <article className="service">
        <div className="service__head">
          <h3>The rationale for technologies used :-</h3>
        </div>

        <ul className="service__list">
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>The key software for this app include React js, Node js and firebase for data storage. Sendgrid email api was used to send emals on behalf of recruiters and businesses.</p>
          </li>
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>Amazon S3 storage was also employed, to store assets belonging to candidates such as resumes, photos etc.</p>
          </li>
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p> React Emojify (library) is also made use of here to convert typed symbols to emojis in the input container.</p>
          </li>
          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>Socket.io was used on the backend and socket.io-client on the front end.</p>
          </li>

          <li>
            <BiCaretRight className='service__list-icon'/>
            <p>On triggering of certain events the socket connections were made to broadcast a message to all users / emit to all users minus the sender.</p>
          </li>
          
        </ul>
      </article>
     
    
  </div>     
    
  <div style={{display:"flex",justifyContent:"center",margin:"4rem"}}>
       <Link to={"/#portfolio"}><a href="#" className="btn btn-primary">Home</a></Link> 
     </div>
     
    </section>

     {/*END OF  DESCRITPION SECTION*/}
      
    <Footer/>
      
      </div>
    )
  }
  
  export default Item1